export default {
  "hero.title": "USFansSpreadsheet – Kompletny przewodnik, porównania i najlepsze rozwiązania 2026",
  "hero.subtitle": "Dowiedz się, jak działa USFansSpreadsheet, porównaj funkcje i wybierz najlepsze narzędzie.",
  "hero.check_1": "Aktualne porównania",
  "hero.check_2": "Testy i recenzje",
  "hero.check_3": "Bezpieczeństwo danych",
  "hero.check_4": "Instrukcje krok po kroku",
  "hero.btn_usfans": "USFans Spreadsheet",
  "hero.btn_buy": "Buy It Now",
  "hero.cta_text": "Sprawdź rozwiązanie",

  "categories.title": "Wybierz kategorię",
  "categories.all": "Kategorie",
  "categories.goto": "Przejdź do sklepu",

  "benefits.title": "Dlaczego użytkownicy wybierają USFansSpreadsheet?",
  "benefits.brand": "USFANSSPREADSHEET",
  "benefits.card_1_title": "Bezpieczeństwo danych",
  "benefits.card_1_desc": "Twoje informacje są chronione najwyższymi standardami szyfrowania i prywatności.",
  "benefits.card_2_title": "Porównania z Excel",
  "benefits.card_2_desc": "Zobacz, jak USFansSpreadsheet wypada na tle tradycyjnych rozwiązań.",
  "benefits.card_3_title": "Wydajność i automatyzacja",
  "benefits.card_3_desc": "Oszczędzaj czas dzięki inteligentnym funkcjom automatyzacji i szybkiemu przetwarzaniu danych.",

  "comparison.title": "USFansSpreadsheet – porównanie funkcji",
  "comparison.subtitle": "Zobacz, jak nasze rozwiązanie wypada na tle konkurencji w kluczowych obszarach.",

  "reviews.label": "(Recenzje użytkowników)",
  "reviews.title_line1": "Opinie o",
  "reviews.title_line2": "USFansSpreadsheet",
  "reviews.prev": "Poprzednia",
  "reviews.next": "Następna",

  "security.label": "Bezpieczeństwo i prywatność",
  "security.title_line1": "Twoje dane",
  "security.title_line2": "są z nami",
  "security.title_line3": "w pełni bezpieczne",
  "security.cert_btn": "Sprawdź certyfikaty",
  "security.read_btn": "Czytaj więcej",

  "faq.title": "Najczęściej zadawane pytania",
  "faq.subtitle": "Wszystko, co musisz wiedzieć o USFansSpreadsheet",

  "articles.title": "Artykuły i poradniki",
  "articles.subtitle": "Poznaj szczegółowe przewodniki i analizy dotyczące USFansSpreadsheet",
  "articles.read_more": "Czytaj więcej",

  "cta.title": "USFansSpreadsheet 2026 – Gotowy na najlepsze rozwiązanie?",
  "cta.subtitle": "Sprawdź pełne możliwości na naszej głównej stronie.",
  "cta.button": "Kup teraz na kaspreadsheet.com",

  "footer.brand_desc": "Kompletny przewodnik, porównania i najlepsze rozwiązania USFansSpreadsheet w 2026 roku.",
  "footer.categories": "Kategorie",
  "footer.articles": "Artykuły SEO",
  "footer.faq": "FAQ",
  "footer.copyright": "© USFansSpreadsheet 2026",
  "footer.rights": "Wszelkie prawa zastrzeżone.",
  "footer.motto": "Elegancja / Precyzja / Styl",
  "footer.subscribe_title": "Zapisz się do newslettera",
  "footer.subscribe_desc": "Otrzymuj najnowsze porównania i poradniki.",
  "footer.subscribe_btn": "Zapisz się",
  "footer.home": "Strona główna",
};